import { createReducer } from "typesafe-actions";

import CoachingNoteCategory from "@app/scene/dashboard/types/CoachingNoteCategory";

import {
  CoachingNoteCategoriesActions,
  createCoachingNoteCategory,
  deleteCoachingNoteCategory,
  fetchCoachingNoteCategories,
  reorderCoachingNoteCategories,
  updateCoachingNoteCategory,
} from "./actions";

export interface CoachingNoteCategoriesState {
  categories: CoachingNoteCategory[];
  loading: boolean;
}

export const initialCoachingNoteCategoriesState: CoachingNoteCategoriesState = {
  categories: [],
  loading: false,
};

const coachingNoteCategories = createReducer<
  CoachingNoteCategoriesState,
  CoachingNoteCategoriesActions
>(initialCoachingNoteCategoriesState)
  .handleAction(fetchCoachingNoteCategories.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchCoachingNoteCategories.success, (state, { payload }) => ({
    ...state,
    categories: payload,
    loading: false,
  }))
  .handleAction(fetchCoachingNoteCategories.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(createCoachingNoteCategory.success, (state, { payload }) => ({
    ...state,
    categories: [...state.categories, payload],
  }))
  .handleAction(deleteCoachingNoteCategory.success, (state, { payload }) => ({
    ...state,
    categories: state.categories.filter((category) => category.id !== payload.categoryId),
  }))
  // Optimistic: snap to the new order immediately so the drag drop doesn't
  .handleAction(reorderCoachingNoteCategories.request, (state, { payload }) => {
    const byId = new Map(state.categories.map((category) => [category.id, category]));
    const reordered = payload.orderedIds
      .map((id, index) => {
        const category = byId.get(id);
        return category ? { ...category, displayOrder: index + 1 } : undefined;
      })
      .filter((category): category is CoachingNoteCategory => category !== undefined);
    return { ...state, categories: reordered };
  })
  .handleAction(reorderCoachingNoteCategories.success, (state, { payload }) => ({
    ...state,
    categories: payload,
  }))
  .handleAction(updateCoachingNoteCategory.success, (state, { payload }) => ({
    ...state,
    categories: state.categories.map((category) =>
      category.id === payload.id ? payload : category
    ),
  }));

export default coachingNoteCategories;
